import { render, staticRenderFns } from "./KickCombos.vue?vue&type=template&id=4085ae10&scoped=true&"
import script from "./KickCombos.vue?vue&type=script&lang=js&"
export * from "./KickCombos.vue?vue&type=script&lang=js&"
import style0 from "./KickCombos.vue?vue&type=style&index=0&id=4085ae10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4085ae10",
  null
  
)

export default component.exports